let lastReviewEventKey: string | null = null
let lastAssessmentItemViewEventKey: string | null = null

export const shouldSkipReviewEvent = (eventKey: string): boolean => {
  if (eventKey === lastReviewEventKey) {
    return true
  }

  lastReviewEventKey = eventKey
  return false
}

export const shouldSkipAssessmentItemViewEvent = (eventKey: string): boolean => {
  if (eventKey === lastAssessmentItemViewEventKey) {
    return true
  }

  lastAssessmentItemViewEventKey = eventKey
  return false
}

export const resetEventDedupState = (): void => {
  lastReviewEventKey = null
  lastAssessmentItemViewEventKey = null
}
